import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface CreateSessionPayload {
  user_name: string;
  user_email: string;
  user_role: string;
}

export interface CreateSessionResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: { session_id: string };
}

export interface HeartbeatPayload {
  active_seconds: number;
}

export interface EndSessionPayload {
  logout_type: 'manual' | 'idle_timeout' | 'session_timeout';
  active_seconds?: number;
}

export interface SessionApiItem {
  _id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  user_role: string;
  login_at: string;
  logout_at: string | null;
  logout_type: 'manual' | 'idle_timeout' | 'session_timeout' | null;
  last_activity_at: string;
  total_active_seconds: number;
  ip_address: string;
  user_agent: string;
  createdAt: string;
  updatedAt: string;
}

export interface SessionsListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: { sessions: SessionApiItem[]; count: number };
}

export const createSession = async (payload: CreateSessionPayload): Promise<CreateSessionResponse> => {
  return api.post<CreateSessionResponse, CreateSessionPayload>(API_ENDPOINTS.sessions.create, payload);
};

export const heartbeat = async (sessionId: string, payload: HeartbeatPayload): Promise<void> => {
  await api.put<unknown, HeartbeatPayload>(`${API_ENDPOINTS.sessions.base}/${sessionId}/heartbeat`, payload);
};

export const endSession = async (sessionId: string, payload: EndSessionPayload): Promise<void> => {
  await api.put<unknown, EndSessionPayload>(`${API_ENDPOINTS.sessions.base}/${sessionId}/end`, payload);
};

export const getSessions = async (params?: {
  user_id?: string;
  page?: number;
  limit?: number;
  from?: string;
  to?: string;
  logout_type?: string;
}): Promise<SessionsListResponse> => {
  const query = new URLSearchParams();
  if (params?.user_id) query.set('user_id', params.user_id);
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.from) query.set('from', params.from);
  if (params?.to) query.set('to', params.to);
  if (params?.logout_type) query.set('logout_type', params.logout_type);
  const qs = query.toString();
  return api.get<SessionsListResponse>(`${API_ENDPOINTS.sessions.base}${qs ? `?${qs}` : ''}`);
};
